import * as React from 'react';
import { ErrorMessage } from '../error-message';
import { FormFieldLabel } from '../form-field-label';
import * as Styled from './textarea.styled';
interface TextareaProps extends React.PropsWithChildren<JSX.IntrinsicElements['textarea'] & Styled.TextareaElementProps> {
  label: string;
  errorMessage?: string;
}
export const Textarea = React.memo(function Textarea({
  label,
  errorMessage,
  ...props
}: TextareaProps) {
  return <Styled.Wrapper>
      <FormFieldLabel>{label}</FormFieldLabel>
      <Styled.Textarea {...props} $hasError={!!errorMessage} />
      {errorMessage ? <ErrorMessage message={errorMessage} /> : null}
    </Styled.Wrapper>;
});